import * as React from "react";
import type { SVGProps } from "react";
import { memo } from "react";
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{"icon18/\u8BED\u4E49\u89C4\u5219\u62BD\u53D6"}</title>
    <defs>
      <radialGradient
        cx="11.3172631%"
        cy="2.52121261%"
        fx="11.3172631%"
        fy="2.52121261%"
        r="124.298356%"
        id="FtX-rtHpcBt8PiCGfMM7f__radialGradient-1"
      >
        <stop stopColor="#8FC3FF" offset="0%" />
        <stop stopColor="#6C83FF" offset="100%" />
      </radialGradient>
      <rect
        id="FtX-rtHpcBt8PiCGfMM7f__path-2"
        x={0}
        y={0}
        width={18}
        height={18}
        rx={2}
      />
      <filter
        x="-5.6%"
        y="-5.6%"
        width="111.1%"
        height="111.1%"
        filterUnits="objectBoundingBox"
        id="FtX-rtHpcBt8PiCGfMM7f__filter-3"
      >
        <feGaussianBlur
          stdDeviation={0.5}
          in="SourceAlpha"
          result="shadowBlurInner1"
        />
        <feOffset
          dx={0}
          dy={1}
          in="shadowBlurInner1"
          result="shadowOffsetInner1"
        />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2={-1}
          k3={1}
          result="shadowInnerInner1"
        />
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.0530553431 0"
          type="matrix"
          in="shadowInnerInner1"
        />
      </filter>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="100%"
        id="FtX-rtHpcBt8PiCGfMM7f__linearGradient-4"
      >
        <stop stopColor="#F7F9FF" offset="0%" />
        <stop stopColor="#DCE6FF" offset="100%" />
      </linearGradient>
      <rect
        id="FtX-rtHpcBt8PiCGfMM7f__path-5"
        x={3.5}
        y={3.5}
        width={9}
        height={1.5}
        rx={0.75}
      />
      <filter
        x="-22.2%"
        y="-66.7%"
        width="144.4%"
        height="366.7%"
        filterUnits="objectBoundingBox"
        id="FtX-rtHpcBt8PiCGfMM7f__filter-6"
      >
        <feOffset dx={0} dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={0.5}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0.295527282   0 0 0 0 0.423435616   0 0 0 0 0.899094734  0 0 0 0.176822689 0"
          type="matrix"
          in="shadowBlurOuter1"
        />
      </filter>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="100%"
        id="FtX-rtHpcBt8PiCGfMM7f__linearGradient-7"
      >
        <stop stopColor="#F7F9FF" offset="0%" />
        <stop stopColor="#DCE6FF" offset="100%" />
      </linearGradient>
      <rect
        id="FtX-rtHpcBt8PiCGfMM7f__path-8"
        x={3.5}
        y={8}
        width={4}
        height={1.5}
        rx={0.75}
      />
      <filter
        x="-50.0%"
        y="-66.7%"
        width="200.0%"
        height="366.7%"
        filterUnits="objectBoundingBox"
        id="FtX-rtHpcBt8PiCGfMM7f__filter-9"
      >
        <feOffset dx={0} dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={0.5}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0.295527282   0 0 0 0 0.423435616   0 0 0 0 0.899094734  0 0 0 0.176822689 0"
          type="matrix"
          in="shadowBlurOuter1"
        />
      </filter>
      <linearGradient
        x1="85.9690315%"
        y1="47.3726218%"
        x2="6.60781473%"
        y2="45.2954861%"
        id="FtX-rtHpcBt8PiCGfMM7f__linearGradient-10"
      >
        <stop stopColor="#C4D6FF" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <path
        d="M10.213221,13.8905934 L9.66001245,15.3339781 C9.58457492,15.5347969 9.47980058,15.6958703 9.34568942,15.8171983 C9.21157826,15.9385262 9.0146025,15.9991902 8.75476213,15.9991902 C8.49492176,15.9991902 8.28746856,15.9280669 8.13240253,15.7858203 C7.9773365,15.6435737 7.95847712,15.4009177 8.07582439,15.0578524 L10.6658461,7.51459805 C10.7077559,7.38071888 10.7978618,7.26148275 10.9361639,7.15688965 C11.0744661,7.05229655 11.2609644,7 11.4956589,7 C11.7303535,7 11.9168518,7.05229655 12.0551539,7.15688965 C12.1934561,7.26148275 12.283562,7.38071888 12.3254717,7.51459805 L14.9406393,15.0829547 C15.0412227,15.4009177 15.0139814,15.6331144 14.8589153,15.7795447 C14.7038493,15.9259751 14.4963961,15.9991902 14.2365557,15.9991902 C13.9767154,16.0075577 13.7839306,15.9510774 13.6582014,15.8297494 C13.5324722,15.7084214 13.4360798,15.564083 13.3690242,15.396734 L12.765524,13.8905934 L10.213221,13.8905934 Z M12.4637739,12.4723109 L11.4956589,9.35962032 L10.527544,12.4723109 L12.4637739,12.4723109 Z"
        id="FtX-rtHpcBt8PiCGfMM7f__path-11"
      />
      <filter
        x="-100.0%"
        y="-55.6%"
        width="300.0%"
        height="255.6%"
        filterUnits="objectBoundingBox"
        id="FtX-rtHpcBt8PiCGfMM7f__filter-12"
      >
        <feOffset dx={0} dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={2}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0.0966327685   0 0 0 0 0.24633474   0 0 0 0 0.707915817  0 0 0 0.280951227 0"
          type="matrix"
          in="shadowBlurOuter1"
        />
      </filter>
    </defs>
    <g
      id="FtX-rtHpcBt8PiCGfMM7f__icon18/\u8BED\u4E49\u89C4\u5219\u62BD\u53D6"
      stroke="none"
      strokeWidth={1}
      fill="none"
      fillRule="evenodd"
    >
      <g id="FtX-rtHpcBt8PiCGfMM7f__\u77E9\u5F62">
        <use
          fill="url(#FtX-rtHpcBt8PiCGfMM7f__radialGradient-1)"
          fillRule="evenodd"
          xlinkHref="#FtX-rtHpcBt8PiCGfMM7f__path-2"
        />
        <use
          fill="black"
          fillOpacity={1}
          filter="url(#FtX-rtHpcBt8PiCGfMM7f__filter-3)"
          xlinkHref="#FtX-rtHpcBt8PiCGfMM7f__path-2"
        />
      </g>
      <g id="FtX-rtHpcBt8PiCGfMM7f__\u77E9\u5F62">
        <use
          fill="black"
          fillOpacity={1}
          filter="url(#FtX-rtHpcBt8PiCGfMM7f__filter-6)"
          xlinkHref="#FtX-rtHpcBt8PiCGfMM7f__path-5"
        />
        <use
          fill="url(#FtX-rtHpcBt8PiCGfMM7f__linearGradient-4)"
          fillRule="evenodd"
          xlinkHref="#FtX-rtHpcBt8PiCGfMM7f__path-5"
        />
      </g>
      <g id="FtX-rtHpcBt8PiCGfMM7f__\u77E9\u5F62\u5907\u4EFD-8">
        <use
          fill="black"
          fillOpacity={1}
          filter="url(#FtX-rtHpcBt8PiCGfMM7f__filter-9)"
          xlinkHref="#FtX-rtHpcBt8PiCGfMM7f__path-8"
        />
        <use
          fill="url(#FtX-rtHpcBt8PiCGfMM7f__linearGradient-7)"
          fillRule="evenodd"
          xlinkHref="#FtX-rtHpcBt8PiCGfMM7f__path-8"
        />
      </g>
      <g id="FtX-rtHpcBt8PiCGfMM7f__\u5F62\u72B6">
        <use
          fill="black"
          fillOpacity={1}
          filter="url(#FtX-rtHpcBt8PiCGfMM7f__filter-12)"
          xlinkHref="#FtX-rtHpcBt8PiCGfMM7f__path-11"
        />
        <use
          fill="url(#FtX-rtHpcBt8PiCGfMM7f__linearGradient-10)"
          fillRule="evenodd"
          xlinkHref="#FtX-rtHpcBt8PiCGfMM7f__path-11"
        />
      </g>
    </g>
  </svg>
);
const Memo = memo(Icon);
export default Memo;
